// Angular
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
// Material
import { MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule } from '@angular/material';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
// CRUD
import { InterceptService } from '../../../core/_base/crud/';
// Module components
import { AuthComponent } from './auth.component';
import { LoginComponent } from './login/login.component';
import {CallbackComponent} from "./callback/callback.component";
import {AuthService} from "../../../services/security/auth.service";
import {OAUTHService} from "../../../services/oauth.service";
import {AuthenticationService} from "../../../core/auth/authentication.service";
import {TokenStorage} from "../../../core/auth/token-storage.service";
import {UtilsService} from "../../../services/utils.service";
import {HttpAddAuthorizationHeaderInterceptor} from "../../../services/security/http-auth-header.interceptor";
import {HttpErrorInterceptor} from "../../../services/security/http-error.interceptor";
import {ToastrService} from "ngx-toastr";
// Auth

const routes: Routes = [
	{
		path: '',
		component: AuthComponent,
		children: [
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: 'login',
				component: LoginComponent,
				data: {returnUrl: window.location.pathname}
			},
			{
				path: 'callback',
				component: CallbackComponent
			}
		]
	}
];


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatButtonModule,
		RouterModule.forChild(routes),
		MatInputModule,
		MatFormFieldModule,
		MatCheckboxModule,
		TranslateModule.forChild(),
	],
	providers: [
		AuthService,
		OAUTHService,
		AuthenticationService,
		TokenStorage,
		UtilsService,
	],
	exports: [AuthComponent],
	declarations: [
		AuthComponent,
		LoginComponent,
		CallbackComponent
	]
})

export class AuthModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: AuthModule,
			providers: [
			]
		};
	}
}
